/** 로그인 흐름 보류 상태(returnUrl 등)의 유효 기간(ms) — 10분. 백엔드 signup_handoff TTL 과 동일. */
export const LOGIN_FLOW_TTL_MS = 10 * 60 * 1000;
